import { EllipsisOutlined } from '@ant-design/icons'
import type { components } from '@fluencelabs/vodopad-admin-api'
import {
  Button,
  Dropdown,
  type MenuProps,
  type TableColumnsType,
  Typography,
} from 'antd'

import { FormattedDate } from '@/components/common/FormattedDate'
import { MONO_STYLE } from '@/components/common/MonoId'
import { StatusTag } from '@/components/common/StatusTag'
import { ACCOUNT_STATUS_COLORS } from '@/constants/statuses'

type AdminUserDto = components['schemas']['AdminUserDto']
type AccountStatus = components['schemas']['AccountStatus']

export function userColumns(
  getMenuItems: (record: AdminUserDto) => MenuProps['items'],
  onAction: (key: string, record: AdminUserDto) => void,
): TableColumnsType<AdminUserDto> {
  return [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 160,
      ellipsis: true,
      render: (id: string) => (
        <Typography.Text copyable={{ text: id }} style={MONO_STYLE}>
          {id.slice(0, 8)}...
        </Typography.Text>
      ),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: 200,
      ellipsis: true,
      render: (email: string) => (
        <Typography.Text
          copyable={{ text: email }}
          ellipsis={{ tooltip: email }}
          style={{ maxWidth: '100%' }}
        >
          {email}
        </Typography.Text>
      ),
    },
    {
      title: 'Role',
      dataIndex: 'roleName',
      key: 'roleName',
      width: 130,
      render: (role: string) => (
        <StatusTag status={role} colorMap={{ Admin: 'red', User: 'blue' }} />
      ),
    },
    {
      title: 'Group',
      dataIndex: 'groupName',
      key: 'groupName',
      width: 120,
      ellipsis: true,
      render: (group: string) => group || '—',
    },
    {
      title: 'Status',
      dataIndex: 'accountStatus',
      key: 'accountStatus',
      width: 110,
      render: (status: AccountStatus) => (
        <StatusTag status={status} colorMap={ACCOUNT_STATUS_COLORS} />
      ),
    },
    {
      title: 'Payment',
      dataIndex: 'paymentType',
      key: 'paymentType',
      width: 100,
    },
    {
      title: 'Created',
      dataIndex: 'registeredAt',
      key: 'registeredAt',
      width: 120,
      render: (date: string) => <FormattedDate date={date} />,
    },
    {
      title: 'Last Login',
      dataIndex: 'lastLoginAt',
      key: 'lastLoginAt',
      width: 120,
      render: (date: string) => <FormattedDate date={date} />,
    },
    {
      title: '',
      key: 'actions',
      width: 50,
      render: (_: unknown, record: AdminUserDto) => (
        <Dropdown
          menu={{
            items: getMenuItems(record),
            onClick: ({ key }) => onAction(key, record),
          }}
          trigger={['click']}
        >
          <Button type="text" icon={<EllipsisOutlined />} />
        </Dropdown>
      ),
    },
  ]
}
